import { Paper, Stack, Typography } from '@lingoda/ui';

interface Props {
    title?: string;
}

export const ChallengesPaper = ({ title, children }: React.PropsWithChildren<Props>) => {
    return (
        <Paper variant="outlined" sx={{ padding: (theme) => theme.spacing(3) }}>
            <Stack spacing={2}>
                {title && <Typography variant="subtitle1">{title}</Typography>}
                {children}
            </Stack>
        </Paper>
    );
};
